export default "__VITE_ASSET__C8A59j9v__"